@use '@design/design-tokens/typography/typography' as *;

.graphCards {
  gap: 40px;
}

.geoExposureHeader {
  display: flex;
  flex-direction: column;
}

.geoExposureTitle {
  @include typography-v2-title-sm;
  color: var(--text-decorative-gold);
}

.geoExposureDescription {
  @include typography-v2-body-md;
}
